import { render } from "./WebchatConfig.vue?vue&type=template&id=2a500a31&scoped=true&lang=pug"
import script from "./WebchatConfig.vue?vue&type=script&lang=js"
export * from "./WebchatConfig.vue?vue&type=script&lang=js"

import "./WebchatConfig.vue?vue&type=style&index=0&id=2a500a31&lang=scss&scoped=true"
import "./WebchatConfig.vue?vue&type=style&index=1&id=2a500a31&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a500a31"]])

export default __exports__